/**
 * @generated SignedSource<<b56447ef929f2c31cd5c32a11055ddcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDeliveryOptions_deliveryOptions$data = ReadonlyArray<{
  readonly isLocalPickup: boolean | null;
  readonly serviceId: string | null;
  readonly showQuoteAsPending: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerLocalPickup_localPickupQuote" | "BuyerPreQuotedOptions_deliveryOptions" | "BuyerShipmentRequest_deliveryOptions" | "CheckoutAllowCustomQuote_deliveryOptions" | "DeactivatedQuotes_deliveryOptions">;
  readonly " $fragmentType": "CheckoutDeliveryOptions_deliveryOptions";
}>;
export type CheckoutDeliveryOptions_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutDeliveryOptions_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptions_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutDeliveryOptions_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerLocalPickup_localPickupQuote"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerPreQuotedOptions_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerShipmentRequest_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAllowCustomQuote_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeactivatedQuotes_deliveryOptions"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocalPickup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "d785c54924410e493412a0960a63ac54";

export default node;
